/**
 * Sarthi Vendor Application Version Configuration
 * Represents the version of the currently running frontend bundle.
 * Auto-generated by bump-version.js
 */

export const APP_VERSION = '1.2.33';
export const BUILD_TIME = '2026-11-03T13:06:19.702Z';
export const GIT_COMMIT = '631c155';

export const getActiveAppVersion = () => {
  return APP_VERSION;
};

export const getActiveGitCommit = () => {
  return GIT_COMMIT;
};

export const getActiveBuildTime = () => {
  return BUILD_TIME;
};

export const setAcknowledgedVersion = (version) => {
  try {
    if (version) {
      sessionStorage.setItem('sarthi_vendor_acknowledged_version', String(version).trim());
    }
  } catch (e) {
    // Ignore storage issues
  }
};
